import React from 'react';
import TabbedPage from '../../../../Elements/TabbedPage';
import TpClientPaymentsAdmin from '../../../ThirdParty/TpClientPayment/TpClientPaymentsAdmin';
import PaymentsAppliedTab from './PaymentsAppliedTab';

// The parameter is used for both old and new client invoice IDs
const ClientInvoicePaymentsAppliedTabs = ({ tpClientInvoiceId = 0 }) => {
  const tabs = [
    {
      label: 'Payments Applied',
      id: 'paymentsapplied',
      icon: 'fa-solid fa-file-invoice',
      component: <PaymentsAppliedTab clientInvoiceId={tpClientInvoiceId} />,
    },
    {
      label: 'New Payments Applied',
      id: 'newpaymentsapplied',
      icon: 'fa-solid fa-file-invoice-dollar',
      component: (
        <TpClientPaymentsAdmin
          tpClientInvoiceId={tpClientInvoiceId}
          isOldInvoiceAppliedView={true}
        />
      ),
    },
  ];

  return (
    <div className='contentwrapper'>
      <TabbedPage
        tabs={tabs}
        removeSearchParametersOnTabChange={true}
      />
    </div>
  );
};

export default ClientInvoicePaymentsAppliedTabs;
